// `avatar review [--accept-all|--reject-all]` — Command 05 spec.
// Interactive review of .claude/_pending/*.diff.md proposals.
import type { Command } from "commander";
import { notImplementedYet } from "../lib/not-implemented-stub.js";

export function registerReviewCommand(program: Command): void {
  program
    .command("review")
    .description("Review pending proposals từ avatar scan (M08)")
    .option("--accept-all", "Approve mọi pending không hỏi (CI mode)")
    .option("--reject-all", "Xóa mọi pending không hỏi")
    .action(notImplementedYet("review", "Milestone 08"));
}
